import { getVolume3DProjectionSnapshot, volume3DProjectionAdapter, } from './volume3DProjectionAdapter.js';
export { DefaultVolume3DDataProvider } from './DefaultVolume3DDataProvider.js';
export { createDefaultVolume3DRenderPaths, createVolume3DRenderPathResolver, } from './Volume3DRenderPathResolver.js';
export const volume3DProjection = {
    adapter: volume3DProjectionAdapter,
    getSnapshot: getVolume3DProjectionSnapshot,
};
export { default } from './viewport3D.js';
